<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="icon/clean" clip-path="url(#clip0_10179_58252)">
      <rect
        id="Rectangle 253"
        x="2"
        y="2"
        width="20"
        height="20"
        rx="10"
        fill="#F4F4F5"
      />
      <g id="Group 130">
        <path
          id="Vector 44"
          d="M9 9L15 15"
          stroke="#6B6B6F"
          stroke-width="1.5"
          stroke-linecap="round"
        />
        <path
          id="Vector 45"
          d="M15 9L9 15"
          stroke="#6B6B6F"
          stroke-width="1.5"
          stroke-linecap="round"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_10179_58252">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<script lang="ts" setup></script>

<style></style>
